// extracted by mini-css-extract-plugin
export default {"spinner":"nMqNDz","rotate":"Vz5vkY","path":"FGzRng","small":"jOFB2d","dash-small":"h5_KBp","dashSmall":"h5_KBp","medium":"kT_JnN","dash-medium":"kKJE1u","dashMedium":"kKJE1u"};